import type { DocumentType, UnreadDocumentCounts } from "../../../types";
import { DOCUMENT_TYPE_TABS } from "../../../constants/documentTypes";

/** Props for personalized unread-report category tabs. */
interface DocumentTypeTabsProps {
  activeType: DocumentType;
  onTypeChange: (type: DocumentType) => void;
  unreadCounts: UnreadDocumentCounts;
}

/**
 * Render document categories with the authenticated user's unread report count.
 *
 * @param props - Active category, selection callback, and unread counts
 * @returns Document category tab strip
 */
export function DocumentTypeTabs({
  activeType,
  onTypeChange,
  unreadCounts,
}: DocumentTypeTabsProps) {
  return (
    <div className="border-b" style={{ borderColor: "var(--color-border)" }}>
      <div className="flex gap-1 overflow-x-auto">
        {DOCUMENT_TYPE_TABS.map((type) => {
          const isActive = activeType === type;
          const count = unreadCounts[type] || 0;

          return (
            <button
              key={type}
              onClick={() => onTypeChange(type)}
              className="relative px-4 py-3 text-sm font-bold whitespace-nowrap transition-colors"
              style={{
                color: isActive
                  ? "var(--color-primary)"
                  : "var(--color-text-secondary)",
                borderBottom: isActive
                  ? "3px solid var(--color-primary)"
                  : "none",
                marginBottom: isActive ? "-1px" : "0",
              }}
            >
              <span className="flex items-center gap-2">
                {type}
                {count > 0 && (
                  <span
                    className="inline-flex items-center justify-center min-w-[20px] h-5 px-1.5 text-xs font-medium rounded-full"
                    style={{
                      backgroundColor: isActive
                        ? "var(--color-primary)"
                        : "var(--color-muted)",
                      color: isActive
                        ? "#ffffff"
                        : "var(--color-muted-foreground)",
                    }}
                  >
                    {count}
                  </span>
                )}
              </span>
            </button>
          );
        })}
      </div>
    </div>
  );
}
